import { paramsHook } from 'external/deep-diff'
import { cloneDeep, isUUID } from 'external/lodash'
import { offerService } from 'services/offer.service'
import { adminService } from 'services/admin.service'
import { emptyOffer } from 'types/offer'
import { isLoggedIn, isLoggedInAndInRoute } from 'utilities/navigate'
import { Course, isElective } from 'types/course'

const hooks =  [
  {paths: paramsHook('pageName', 'offerId'), resolves: [fetchOffers]},
  {paths: paramsHook('pageName', 'offerId'), resolves: [fetchOffer]},
  {paths: paramsHook('pageName', '?pattern', '?pageSize', '?page', '?sortBy'), resolves: [fetchClients]},
  {paths: paramsHook('pageName', 'clientId', 'purchases/refreshes/', 'courseMap/'), resolves: [fetchClientPurchases]}
]

export {hooks as default}

export async function fetchOffers({update, state}, {contexts}) {
  const clientId = isLoggedInAndInRoute('adminOffers', {state, contexts})
  if (!isUUID(clientId)) return
  const {props: {params: {offerId}}} = state 
  if (isUUID(offerId)) return
  update({offers: {$startLoading: {}}})
  const offers = await offerService.getOffers()
  update({offers: {$updateLoadableList: offers.data.data}}) 
}

export async function fetchOffer({update, state}, {contexts}) {
    const clientId = isLoggedInAndInRoute('adminOfferConfiguration', {state, contexts})
    if (!isUUID(clientId)) return
    const {props: {params: {offerId}}} = state 
    if (!isUUID(offerId)) return
    update({currentOffer: {$set: cloneDeep(emptyOffer)}})
    const response = await offerService.getOffersById(offerId);
    update({currentOffer: {$set: {loaded: true, ...response.data.data}}})
}

export async function fetchClients({update, state}, {contexts}) {
  const userId = isLoggedInAndInRoute(['adminClients', 'accountingClients'], {state, contexts})
  if (!isUUID(userId)) return
  const {props: {query: {pattern, sortBy, pageSize = 10, page = 1}}} = state 
  update({clients: {$startLoading: {}}, clientsPaging: {$set: false}})
  const {data} = await adminService.searchClients(userId, {pattern, sortBy, pageSize, page})
  const {results, paging} = data
  update({clients: {$updateLoadableList: results}, clientsPaging: {$set: paging}}) 
}

export async function fetchClientPurchases({update, state}, {contexts}) {
  if (state.coursesMap === false) return
  const userId = isLoggedInAndInRoute(['adminClient', 'accountingClient'], {state, contexts})
  if (!isUUID(userId)) return
  const {props: {params: {clientId}}} = state 
  if (!isUUID(clientId)) return
  update({client: {loading: {$set: true}, id: {$set: false}, profile: {$set: false}, purchases: {$startLoading: {}}}})
  const {data} = await adminService.clientPurchases(userId, clientId)
  const {purchases, profile} = data
  const parsedPurchases = purchases.map((purchase:any) => {
    const {courses = [], properties = {}} = purchase
    const extra = properties.basicExtra || []
    purchase.courses = {
      all: courses.map(({id}) => id).concat(extra),
      basic: courses.filter((c: Course) => !isElective(c)),
      elective: courses.filter(isElective),
      extra
    }
    return purchase
  }) 
  update({client: {loading: {$set: false}, id: {$set: clientId}, profile: {$set: profile}, purchases: {$updateLoadableList: parsedPurchases}}})
}

export async function fetchCourses({update, state}, {contexts}) {
  const userId = isLoggedIn({state, contexts})
  if (!isUUID(userId)) return
  if (state.coursesMap === false) return
  if (state.courses.loading) return
  update({courses: {$startLoading: {}}, courseMap: {$set: false}})
  const {data = []} = (await adminService.fetchCoursesInfo(userId))
  const [courses = [], subjects = [], grades = []] = data
  const courseMap = courses.reduce((map, course) => {
    map[course.id] = course
    return map
  }, {})
  update({courses: {$updateLoadableList: courses}, courseMap: {$set: courseMap}, subjects: {$set: subjects}, grades: {$set: grades}})
}